import React, { useState } from "react";

const StagesOfWork = ({ data }) => {
    const [expandedStates, setExpandedStates] = useState(
        Array(data.stagesofwork.length).fill(false)
    );

    const [visibleStates, setVisibleStates] = useState(
        Array(data.stagesofwork.length).fill(false)
    );

    const handleClick = (index) => {
        const newExpandedStates = [...expandedStates];
        newExpandedStates[index] = !newExpandedStates[index]; 
        setExpandedStates(newExpandedStates);

        if (!newExpandedStates[index]) {
          
            setTimeout(() => {
                const newVisibleStates = [...visibleStates];
                newVisibleStates[index] = false; 
                setVisibleStates(newVisibleStates);
            }, 200); 
        } else {
            
            const newVisibleStates = [...visibleStates];
            newVisibleStates[index] = true;
            setVisibleStates(newVisibleStates);
        }
    };

    return (
        <div className="flex flex-col leading-tight">
            {
                data.stagesofwork.map((stagesofwork, index) => (
                    <div key={index} className="grid grid-cols-[1fr_3fr_2fr] items-start gap-2 lg:p-0 md:p-5">
                        <span className="md:text-[20px] text-[16px] font-medium" style={{ color: stagesofwork.index_color }}>
                            {stagesofwork.index}
                        </span>
                        <div className="flex flex-col gap-5 font-medium">
                            <span className={`lg:text-[32px] ${expandedStates[index] ? 'md:text-[36px]' : 'md:text-[28px]'} 
                                    text-[20px] font-medium`} style={{ color: stagesofwork.title_color }}
                                >
                                {stagesofwork.title}
                            </span>
                            <span className={`md:text-[18px] text-[16px] ${expandedStates[index] ? 'fade-in' : 'fade-out'}`} 
                                  style={{ color: stagesofwork.desc_color, display: visibleStates[index] ? 'block' : 'none' }}
                                >
                                {stagesofwork.desc}
                            </span>
                        </div>

                        <div className="flex flex-col items-end justify-self-end gap-5">
                            <button className="flex red-custom-button items-center justify-center border-solid rounded-full md:w-12 md:h-12 w-8 h-8" 
                                    onClick={() => handleClick(index)}
                                >
                                <img className={`p-2.5 transition duration-500 ease-linear ${expandedStates[index] ? 'rotate-90' : ''}`} 
                                     src={stagesofwork.arrow} alt="arrow"
                                />
                            </button>
                            <img className={`rounded-xl ${expandedStates[index] ? 'fade-in' : 'fade-out'}`} src={stagesofwork.image} alt="123" 
                                style={{ display: visibleStates[index] ? 'block' : 'none' }} 
                            />   
                        </div>
                        
                        <hr className={`my-5 col-span-3 ${expandedStates[index] ? 'fade-in-border' : 'block'}`} 
                            style={{borderColor: stagesofwork.line_color}}
                        />
                    </div>
                    
                ))
            }
        
        </div>
    );
};

export default StagesOfWork;